module.exports = __webpack_public_path__ + "static/hotblack-store-6477be282bf03c78f470b472529b823d.mp4";